export default __webpack_public_path__ + "static/media/fondo_panel.3752fd52.jpg";